module.exports = __webpack_public_path__ + "img/lg_ring_skip_skip_1_null.53b0b806.png";